import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { OfflineBanner, registerServiceWorker } from './offline';
import brand from './brand.generated.json';
import './styles.css';

document.title = brand.cloudConsoleName;
registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <OfflineBanner />
    <App />
  </StrictMode>,
);
